import { useCallback, useEffect, useState, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import { useGlobalSpinnerActionsContext } from "./../../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "./../../../Context/LanguageContext";
import {
  useAMGSelectedContext,
  useSearchQueryContext,
  useSearchQueryActionContext,
  usePageSizeContext,
  usePageSizeActionContext,
  useCurrentPageContext,
  useCurrentPageActionContext,
  useMainGridSortActionContext,
  useMainGridSortContext,
  useSelectedFunContext,
} from "./../../../Context/GlobalContext";

import equipmentGroupConstants from "./../../../Constants/EquipmentGroupConstants";
import equipmentGroupActions from "./../../../Actions/EquipmentGroupActions";
import equipmentGroupStore from "./../../../Stores/EquipmentGroupStore";

import equipmentConstants from "./../../../Constants/EquipmentConstants";
import equipmentActions from "./../../../Actions/EquipmentActions";
import equipmentStore from "./../../../Stores/EquipmentStore";

import SearchBox_new from "./../../FilterOptions/SearchComponent/SearchBox_new";
import Paginator from "./../../Pagging/Paginator";
import { useSelectedConfigActionContext } from "./../../../Context/GlobalContext";

import _ from "lodash";
import GridTable from "../../ReusableComponent/GridTable/GridTable";
import HeaderBar from "../../ReusableComponent/Header/HeaderBar";
import GridColumn_SettingActions from "../../../Actions/GridColumn_SettingActions";
import GridColumnSettingControl from "../../FilterOptions/GridColumnSettingControl";
import gridColSettingStore from "../../../Stores/GridColumn_SettingStores";
import {
  useSelectedFilterActionsContext,
  useSelectedFilterContext,
  useItemSelectedFilterActionsContext,
  useItemSelectedFilterContext,
} from "../../../Context/GridEquipListContext";
import GridColSettingConstants from "../../../Constants/GridColumn_SettingConstants";
import { equipmentClick } from "../Equipment Selected/EquipmentClick";
import { toast } from "react-toastify";
import EquipmentBulkUpdate from "../../Dashboard/EquipmentBulkOperation/EquipmentBulkUpdate";

const InaktivAnlageUebersicht = ({ fonctionsname, fonctionid }) => {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const selectedAnlageG = useAMGSelectedContext();

  const selectedFilter = useSelectedFilterContext();
  const updateSelectedFilter = useSelectedFilterActionsContext();

  const itemSelectedFilter = useItemSelectedFilterContext();
  const updateListSelectedFilter = useItemSelectedFilterActionsContext();

  const searchQuery = useSearchQueryContext();
  const UpdateSearchQuery = useSearchQueryActionContext();

  const pageSize = usePageSizeContext();
  const currentPage = useCurrentPageContext();

  const UpdateCurrentPage = useCurrentPageActionContext();
  const UpdatePageSize = usePageSizeActionContext();

  const sortBy = useMainGridSortContext();
  const UpdateSortBy = useMainGridSortActionContext();

  const selectedFuncId = useSelectedFunContext();
  const updateSelectedConfig = useSelectedConfigActionContext();

  const navigate = useNavigate();

  //----variable deklaration
  const [renderMe, setRenderMe] = useState(null);
  const [data, setData] = useState(null);
  const isMountedRef = useRef(null);
  const [refresh, setRefresh] = useState(0);
  const [columns, setColumns] = useState(null);
  const [openSearchBox, setOpenSearchBox] = useState(false);
  const [clearfilter, setClearFilter] = useState(false);
  const [showSearchDialog, setShowSearchDialog] = useState(false);
  const currentPageRef = useRef();
  currentPageRef.current = currentPage;
  //-----------------

  const [disabledSavedFilter, setDisabledSavedFilter] = useState(false);
  const [tableData, setTableData] = useState({
    data: [],
    headerName: [],
    headers: {},
    filterName: [],
  });
  const [gridAction, setGridAction] = useState({
    actionName: [],
    functionHandler: "",
  });
  const [paginatorData, setpaginatorData] = useState({
    pageCount: "",
    pageSize: "",
    firstRowOnPage: "",
    lastRowOnPage: "",
    rowCount: "",
    rowLength: 0,
  });
  const [_orginalResponse, set_orginalResponse] = useState([]);
  const [renderTable, setRenderTable] = useState("");
  const headerBarControl = {
    clientFilter: true,
    filter: true,
    actionList: true,
    isPaginator: true,
  };
  const [dropValueToHeader, setDropValueToHeader] = useState([]);
  const [tablefunctions, setTablefunctions] = useState(null);
  const [showFilterMenu, setShowFilterMenu] = useState(false);
  const [bulkUpdatePopOver, setBulkUpdatePopOver] = useState(false);
  const [selectedAction, setSelectedAction] = useState("");
  const [rowCount, setRowCount] = useState(null);

  const reportCode = "InactivEquip";
  const resetFilter = (e) => {
    e.preventDefault();
  };

  const openSearchBoxEvent = (e) => {
    e.preventDefault();
    setOpenSearchBox(true);
  };

  const closeMsg = () => {
    setOpenSearchBox(false);
  };

  const loadData = () => {
    if (sortBy.key !== "") {
      const FilterId = selectedFilter.length > 0 ? selectedFilter[0].id : null;
      if (itemSelectedFilter.length == 0) {
        setClearFilter(true);
      }
      setGlobalSpinner(true);
      equipmentGroupActions.getEquipmentList2(
        reportCode,
        sortBy.order,
        selectedAnlageG,
        parseInt(currentPage),
        parseInt(pageSize),
        sortBy.key,
        FilterId,
        itemSelectedFilter,
      );
      GridColumn_SettingActions.getSaveFilterList(selectedAnlageG, reportCode);
    }
  };

  const fetchData = useCallback(() => {
    if (selectedAnlageG !== null && selectedAnlageG !== undefined) {
      setGlobalSpinner(true);
      loadData();
    }
  }, [selectedAnlageG, pageSize, searchQuery, currentPage, sortBy]);

  const requestSort = (key) => {
    UpdateSortBy(key);
  };

  const handleCheckEvent = (item) => {
    setGlobalSpinner(true);
    equipmentActions.UpdateEquipmentStatus(
      item.id,
      "INBE",
      sessionStorage.getItem("userid"),
    );
  };
  const handleDropDownSelChange = (item) => {
    if (item !== "") {
      GridColumn_SettingActions.getSaveFilterValue(item, reportCode);
    }

    if (currentPage !== 1) {
      UpdateCurrentPage(1);
    } else {
      UpdateSortBy("InventarNr");
    }
  };
  const handleRowClicked = (row) => {
    sessionStorage.setItem("eqId", row.id);
    sessionStorage.setItem("invnr", row.inventarnr);
    const path = equipmentClick(row, fonctionid, fonctionsname);
    navigate(path);
  };

  /**-----------------------------------------listner filter value on FilterID Start---------------------------------------*/
  useEffect(() => {
    function getSaveFilterValueSuccess() {
      var res = gridColSettingStore.getSavedFilterValueInactiveResult();
      if (res.length > 0) {
        updateListSelectedFilter(res);
      } else {
        updateListSelectedFilter([]);
        setGlobalSpinner(false);
      }
    }

    function getSaveFilterValueFailure() {
      setGlobalSpinner(false);
      updateListSelectedFilter([]);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_INACTIVE_VALUE_SUCCESS,
      getSaveFilterValueSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_INACTIVE_VALUE_FAILURE,
      getSaveFilterValueFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_INACTIVE_VALUE_SUCCESS,
        getSaveFilterValueSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_INACTIVE_VALUE_FAILURE,
        getSaveFilterValueFailure,
      );
    };
  }, []);

  /**-----------------------------------------listner filter value on FilterID End---------------------------------------*/

  useEffect(() => {
    isMountedRef.current = true;

    if (isMountedRef.current && selectedFuncId == 3) {
      fetchData();
    }

    return () => (isMountedRef.current = false);
  }, [fetchData]);

  useEffect(() => {
    if (refresh === 1) {
      setGlobalSpinner(true);
      loadData();
    }

    return () => {
      setRefresh(0);
    };
  }, [refresh]);

  useEffect(() => {
    let _renderMe = null;
    if (data !== null && data !== undefined) {
      let headerName = [];
      let _header = data.headers;
      let _rows = data.rows;
      let _idPos;
      let _action = data.actions;
      setRowCount(data.rows.length);
      _header.map((item) => {
        headerName.push(item.name);
      });
      headerName.map((item, index) => {
        if (item === "ID") {
          _idPos = index;
        }
      });
      setGridAction({
        actionName: _action,
        functionHandler: handleFunctionCall,
      });
      const _page = data.pagingInfo;
      const _last = (_page.currentPage - 1) * _page.pageSize + data.rows.length;
      const _first = (_page.currentPage - 1) * _page.pageSize + 1;
      setColumns(data.filters);
      set_orginalResponse({
        data: _rows,
        headerName: headerName,
        headers: _header,
        sortBy: sortBy,
        _idPos: _idPos,
      });
      setTableData({
        data: _rows,
        headerName: headerName, //body.results,
        headers: _header,
        sortBy: sortBy,
      });
      setpaginatorData({
        pageCount: data.pagingInfo.pageCount,
        lastRowOnPage: _last,
        firstRowOnPage: _first,
        rowCount: data.pagingInfo.rowCount,
        pageSize: data.pagingInfo.pageSize,
        func1: UpdateCurrentPage,
        func2: UpdatePageSize,
        activePage: data.pagingInfo.currentPage,
        rowLength: data.rows.length,
      });
      setShowSearchDialog(false);
    } else {
      setShowSearchDialog(true);
    }
    setRenderMe(_renderMe);
    return () => {
      setRenderMe(null);
    };
  }, [data]);

  useEffect(() => {
    const _renderTable = (
      <GridTable
        data={tableData}
        handleAction={handleAction}
        requestSort={requestSort}
      />
    );
    setRenderTable(_renderTable);
  }, [tableData]);

  useEffect(() => {
    function updateData() {
      var _details = equipmentGroupStore.getEquipmentInactiveListGrid();
      setData(_details);
      setGlobalSpinner(false);
      updateSelectedConfig("");
    }

    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.GET_GRID_INACTIVE_EQUIPMENTLIST_SUCCESS,
      updateData,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.GET_GRID_INACTIVE_EQUIPMENTLIST_SUCCESS,
        updateData,
      );
    };
  }, []);

  useEffect(() => {
    function updateData() {
      setData(null);
      toast.error(localization.LoadFailure);
      setGlobalSpinner(false);
      updateSelectedConfig("");
    }

    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.GET_GRID_INACTIVE_EQUIPMENTLIST_FAILURE,
      updateData,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.GET_GRID_INACTIVE_EQUIPMENTLIST_FAILURE,
        updateData,
      );
    };
  }, []);

  useEffect(() => {
    function getColSettingSaveSuccess() {
      var res = gridColSettingStore.getsaveGridSettingInactiveResult();
      if (res) {
        setShowFilterMenu(false);

        toast.success(localization.saveSuccessMsg);
        setClearFilter(true);
        setDropValueToHeader([]);
        updateSelectedFilter("");
        UpdateSortBy("InventarNr");
        setOpenSearchBox(false);
        setDisabledSavedFilter(false);
      }
    }

    function getColSettingSaveFailure() {
      var res = gridColSettingStore.getsaveGridSettingInactiveResult();
      setShowFilterMenu(false);
      toast.error(res);
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_SETTING_INACTIVE_SUCCESS,
      getColSettingSaveSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_SETTING_INACTIVE_FAILURE,
      getColSettingSaveFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_SETTING_INACTIVE_SUCCESS,
        getColSettingSaveSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_SETTING_INACTIVE_FAILURE,
        getColSettingSaveFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getFilterSaveSuccess() {
      var res = gridColSettingStore.getSavedFilterInactiveResult();
      if (res) {
        setShowFilterMenu(false);
        setOpenSearchBox(false);
        setDisabledSavedFilter(false);
        toast.success(localization.filterSave);
        updateSelectedFilter([res]);
        GridColumn_SettingActions.getSaveFilterList(
          res.equipmentGroupId,
          reportCode,
        );
        setDropValueToHeader([]);
      }
    }

    function getFilterSaveFailure() {
      var res = gridColSettingStore.getSavedFilterInactiveResult();
      setShowFilterMenu(false);
      toast.error(res);
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_FILTER_INACTIVE_SUCCESS,
      getFilterSaveSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_FILTER_INACTIVE_FAILURE,
      getFilterSaveFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_FILTER_INACTIVE_SUCCESS,
        getFilterSaveSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_FILTER_INACTIVE_FAILURE,
        getFilterSaveFailure,
      );
    };
  }, []);

  useEffect(() => {
    function updateData() {
      setRefresh(0);
      toast.success(localization.updateError);
      setGlobalSpinner(false);
    }

    equipmentStore.addChangeListener(
      equipmentConstants.UPDATE_EQUIPMENTSTATUS_FAILURE,
      updateData,
    );

    return () => {
      equipmentStore.removeChangeListener(
        equipmentConstants.UPDATE_EQUIPMENTSTATUS_FAILURE,
        updateData,
      );
    };
  }, []);

  useEffect(() => {
    function getSaveFilterResultSuccess() {
      var res = gridColSettingStore.getsaveFilterListInactiveResult();
      if (res.length > 0) {
        setDropValueToHeader(res);
      } else {
        setDropValueToHeader([]);
      }
    }

    function SaveFilterResultFailure() {}

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_LIST_INACTIVE_SUCCESS,
      getSaveFilterResultSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_LIST_INACTIVE_FAILURE,
      SaveFilterResultFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_LIST_INACTIVE_SUCCESS,
        getSaveFilterResultSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_LIST_INACTIVE_FAILURE,
        SaveFilterResultFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getEquipListSaveFilterSuccess() {
      var res = gridColSettingStore.getInactiveEquListOnFilterResult();
      if (res) {
        setData(res);
      }
      setGlobalSpinner(false);
    }

    function getEquipListSaveFilterFailure() {
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_EQUI_LIST_ON_INACTIVE_SUCCESS,
      getEquipListSaveFilterSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_EQUI_LIST_ON_INACTIVE_FAILURE,
      getEquipListSaveFilterFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_EQUI_LIST_ON_INACTIVE_SUCCESS,
        getEquipListSaveFilterSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_EQUI_LIST_ON_INACTIVE_FAILURE,
        getEquipListSaveFilterFailure,
      );
    };
  }, []);
  useEffect(() => {
    function getDelSaveFilterResultSuccess() {
      var res = gridColSettingStore.getInactiveDelResult();
      updateSelectedFilter("");
      updateListSelectedFilter([]);
      toast.success(localization.delSuccess);
      if (currentPageRef.current != 1) {
        UpdateCurrentPage(1);
      } else {
        UpdateSortBy("InventarNr");
      }
      setGlobalSpinner(false);
    }

    function getDelSaveFilterResultFailure() {
      const res = gridColSettingStore.getInactiveDelResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.DEL_SAVED_FILTER_INACTIVE_SUCCESS,
      getDelSaveFilterResultSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.DEL_SAVED_FILTER_INACTIVE_FAILURE,
      getDelSaveFilterResultFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.DEL_SAVED_FILTER_INACTIVE_SUCCESS,
        getDelSaveFilterResultSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.DEL_SAVED_FILTER_INACTIVE_FAILURE,
        getDelSaveFilterResultFailure,
      );
    };
  }, []);

  function handleAction(actioName, rowselected, headerNameList) {
    const _row = rowselected;
    let id,
      inventarnr,
      eqBez = "";
    headerNameList.map((item, index) => {
      if (item.name.toLowerCase() === "id") {
        id = parseInt(_row[index].value);
      }
      if (item.name.toLowerCase() === "inventarnr") {
        inventarnr = _row[index].value;
      }
      if (item.name.toLowerCase() === "bezeichnung") {
        eqBez = _row[index].value;
      }
    });

    const row = { id: id, inventarnr: inventarnr, bezeichnung: eqBez };
    switch (actioName) {
      case "ViewEquipmentDetails":
        handleRowClicked(row);
        break;
      case "Active":
        handleCheckEvent(row);
        break;
    }
  }
  function handleCloseFilterModal() {
    setShowFilterMenu(false);
  }

  function handleFilterMenu() {
    setGlobalSpinner(true);
    setShowFilterMenu(true);
  }

  function renderBulkUpdate() {
    setBulkUpdatePopOver(true);
  }

  function handleFunctionCall(e, functionName) {
    switch (functionName) {
      case "DataConfiguration":
        handleFilterMenu();
        break;
      case "ExcelExport":
        break;
      case "BulkStatusUpdate":
        setSelectedAction(functionName);
        renderBulkUpdate();
        break;
    }
  }
  function handleFilterLocal(filterResult) {
    setTableData({
      data: filterResult,
      headerName: _orginalResponse.headerName, //body.results,
      headers: _orginalResponse.headers,
      sortBy: sortBy,
    });
  }

  function deleteSaveFilter(filterId) {
    setGlobalSpinner(true);

    GridColumn_SettingActions.deleteSavedFilter(filterId, reportCode);
  }

  function getEquipmentBasedFilter(filterList) {
    const FilterId = null;
    setGlobalSpinner(true);
    if (filterList.length > 0) {
      if (currentPage === 1) {
        equipmentGroupActions.getEquipmentList2(
          reportCode,
          sortBy.order,
          selectedAnlageG,
          parseInt(1),
          parseInt(pageSize),
          sortBy.key,
          FilterId,
          filterList,
        );
      } else {
        UpdateCurrentPage(1);
      }
    } else {
      updateSelectedFilter("");
      handleDropDownSelChange("");
    }
  }

  function resetClearFilter() {
    setClearFilter(false);
  }

  function handleClose() {
    setBulkUpdatePopOver(false);
  }
  return (
    <div className="container-fluid" id="content">
      <h3 className="page-header">
        {sessionStorage.getItem("plant") + " " + " / "}
        <NavLink
          className={({ isActive }) => (isActive ? "active" : "")}
          to={"/equipmentGrpEqiupment"}
          onClick={() => {
            UpdateSearchQuery(null);
            UpdateSortBy(null);
          }}
        >
          {sessionStorage.getItem("eqBez")}
        </NavLink>
        {" " + " / " + "  " + fonctionsname}{" "}
      </h3>

      <div className="container-fluid">
        <SearchBox_new
          cols={columns}
          isOpen={openSearchBox}
          close={closeMsg}
          Reset={resetFilter}
          clearFilter={clearfilter}
          resetClearFilter={resetClearFilter}
          getEquipmentBasedFilter={getEquipmentBasedFilter}
          ReportId={reportCode}
        />

        <HeaderBar
          headerBarControl={headerBarControl}
          paginationStates={openSearchBoxEvent}
          paginatorData={paginatorData}
          dropValueToHeader={dropValueToHeader}
          tablefunctions={tablefunctions}
          _orginalResponse={_orginalResponse}
          handleFilterLocal={handleFilterLocal}
          disabledSavedFilter={disabledSavedFilter}
          gridAction={gridAction}
          handleDropDownSelChange={handleDropDownSelChange}
          deleteSaveFilter={deleteSaveFilter}
          showSearchDialog={showSearchDialog}
          resetClearFilter={resetClearFilter}
        />
        <div className="table-responsive px-3 table-height">{renderTable}</div>
        {headerBarControl.isPaginator && (
          <Paginator
            pageCount={paginatorData.pageCount}
            activePage={paginatorData.activePage}
            setCurrentPage={paginatorData.func1}
            rowCount={paginatorData.rowCount}
            pageSize={paginatorData.pageSize}
            setPageSize={paginatorData.func2}
            firstRowOnPage={paginatorData.firstRowOnPage}
            lastRowOnPage={paginatorData.lastRowOnPage}
          />
        )}
        {showFilterMenu && (
          <GridColumnSettingControl
            handleCloseModel={handleCloseFilterModal}
            pageId={reportCode}
          />
        )}
        {bulkUpdatePopOver && (
          <EquipmentBulkUpdate
            rowCount={rowCount}
            handleClose={handleClose}
            bulkUpdatePopOver={bulkUpdatePopOver}
            slectedAction={selectedAction}
            reportCode={reportCode}
          />
        )}
      </div>
    </div>
  );
};
export default InaktivAnlageUebersicht;
